import axios from "axios";

export default axios.create({baseURL: 'https://iyhwen.deta.dev/'})